import styled from 'styled-components';
import { Input } from 'ui-components/src/components/atoms/Input';
import { SingleSelect } from 'ui-components/src/components/atoms/Select/Single';

export const Container = styled.div`
  margin-bottom: 1rem;
  padding-top: 12px;
`;

export const Row = styled.div`
  display: flex;
  margin-bottom: 1rem;
  padding-right: 4px;
`;

export const StyledInput = styled(Input)`
  flex: 1;

  &:not(:last-child) {
    margin-right: 4px;
  }
`;

export const StyledUnitSelect = styled(SingleSelect)`
  width: 8rem;
`;

export const StyledTypeSelect = styled(SingleSelect)`
  margin-right: 4px;
  width: 10rem;
`;
